import { publicApi } from "@/lib/axios/instances";

export interface CorporateMessage {
  full_name: string;
  organization: string;
  contacts: string;
  type: string;
  message?: string;
  presentation?: File | null;
  // Старые поля оставлены для обратной совместимости (не удалять)
  email?: string;
  phone?: string;
  theme?: string;
}

export interface HRMessage {
  full_name: string;
  email: string;
  phone: string;
  vacancy: string;
  comment?: string;
  resume: File;
}

export const sendCorporateMessage = async (
  dto: CorporateMessage
): Promise<{ success: boolean; message: string }> => {
  const formData = new FormData();

  formData.append("full_name", dto.full_name);
  formData.append("organization", dto.organization);
  formData.append("contacts", dto.contacts);
  formData.append("type", dto.type);

  if (dto.message) {
    formData.append("message", dto.message);
  }

  // Старые поля (если вдруг передаются) — тоже отправляем
  if (dto.email) {
    formData.append("email", dto.email);
  }
  if (dto.phone) {
    formData.append("phone", dto.phone);
  }
  if (dto.theme) {
    formData.append("theme", dto.theme);
  }

  if (dto.presentation) {
    formData.append("presentation", dto.presentation);
  }

  const { data } = await publicApi.post(
    "/submission/corporate/message",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return data;
};

export const sendHRMessage = async (
  dto: HRMessage
): Promise<{ success: boolean; message: string }> => {

  const formData = new FormData();

  formData.append("full_name", dto.full_name);
  formData.append("email", dto.email);
  formData.append("phone", dto.phone);
  formData.append("vacancy", dto.vacancy);

  if (dto.comment) {
    formData.append("comment", dto.comment);
  }

  formData.append("resume", dto.resume);

  const { data } = await publicApi.post(
    "/submission/hr/message",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return data;
};